export default __webpack_public_path__ + "static/media/like-inactive.49570bcb.svg";